import React from 'react';
import css from './AppLayout.module.scss';
import MiniDrawer from '../components/MiniDrawer/MiniDrawer';

type TAppLayout = {
  children: React.ReactNode;
}

const AppLayout = ({ children }: TAppLayout) => (
  <section className={css.root}>
    <div className={css.navPanel}>
      <MiniDrawer children={children} />
    </div>
  </section>
);

export default AppLayout;
